(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kupo-inquiry-prefill"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kupo-inquiry-prefill')) {
    customElements.define('kupo-inquiry-prefill', class extends HTMLElement {
      connectedCallback() {
        const initialize = () => {
          const form = document.getElementById('KupoContactForm');
          const model = form?.querySelector('#kc-model');
          if (!form || !model) return;
          const params = new URLSearchParams(window.location.search);
          const sku = (params.get('sku') || '').slice(0, 160);
          const product = (params.get('product') || '').slice(0, 400);
          if (!model.value && (sku || product)) model.value = product.toLowerCase().startsWith(sku.toLowerCase()) ? product || sku : [sku, product].filter(Boolean).join(' — ');
          const rawUrl = params.get('product_url');
          if (!rawUrl || form.querySelector('[name="contact[Product URL]"]')) return;
          let url;
          try { url = new URL(rawUrl); } catch { return; }
          if (url.origin !== window.location.origin || !/^\/products\/[^/]+$/.test(url.pathname)) return;
          const cleanUrl = new URL(url.pathname, window.location.origin);
          const variant = url.searchParams.get('variant');
          if (variant && /^\d+$/.test(variant)) cleanUrl.searchParams.set('variant', variant);
          const row = document.createElement('div');
          row.className = 'kc-wide';
          const label = document.createElement('label');
          label.htmlFor = 'kc-product-url';
          label.textContent = this.dataset.urlLabel;
          const input = document.createElement('input');
          input.id = 'kc-product-url';
          input.name = 'contact[Product URL]';
          input.type = 'url';
          input.readOnly = true;
          input.value = cleanUrl.href;
          row.append(label, input);
          const messageRow = form.querySelector('#kc-message')?.closest('.kc-wide');
          if (messageRow) messageRow.before(row);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
        else initialize();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kupo-product-reading"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const nav = document.querySelector('[data-kupo-reading]');
      if (!nav || nav.dataset.ready) return;
      const root = document.getElementById('MainContent');
      if (!root) return;
      const description = root.querySelector('.rich-text__text .product-description');
      const faq = root.querySelector('.rich-text__text .kupo-faq-seo-block, .rich-text__text .kupo-faq-section, .rich-text__text .kupo-faq-seo-section, .rich-text__text .kupo-faq-seo');
      const specs = root.querySelector('.kupo-product-side-panel__content ul, .kupo-product-side-panel__content dl, .kupo-product-side-panel__content table');
      const downloads = root.querySelector('[id^="KupoDownloads-"]');
      if (!description) return;
      const targets = { overview: description, specifications: specs, downloads, faq };
      for (const [key, target] of Object.entries(targets)) {
        const link = nav.querySelector('[data-reading-link="' + key + '"]');
        if (!target) { link.remove(); continue; }
        if (!target.id) target.id = 'kupo-reading-' + key;
        target.classList.add('kupo-reading-target');
        target.setAttribute('tabindex', '-1');
        link.href = '#' + target.id;
        link.addEventListener('click', () => target.focus({ preventScroll: true }));
      }
      if (downloads) {
        const downloadSection = downloads.closest('[data-product-downloads]');
        const downloadLink = nav.querySelector('[data-reading-link="downloads"]');
        const updateDownloadLink = () => {
          downloadLink.hidden = !downloadSection || downloadSection.hidden || !downloadSection.querySelector('[data-download-list] a[href]');
        };
        updateDownloadLink();
        if (downloadSection) {
          new MutationObserver(updateDownloadLink).observe(downloadSection, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
        }
      }
      if (faq) {
        const questions = [...faq.querySelectorAll('h3')].filter(question => !question.closest('details'));
        for (const question of questions) {
          const details = document.createElement('details');
          details.className = 'kupo-reading-faq';
          const summary = document.createElement('summary');
          summary.textContent = question.textContent.trim();
          const answer = document.createElement('div');
          answer.className = 'kupo-reading-answer';
          let next = question.nextSibling;
          while (next && !(next.nodeType === 1 && /^(H2|H3)$/.test(next.tagName))) {
            const following = next.nextSibling;
            answer.append(next);
            next = following;
          }
          details.append(summary, answer);
          question.before(details);
          question.remove();
        }
      }
      nav.dataset.ready = 'true';
      nav.hidden = false;
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kupo-product-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kupo-product-support')) {
    customElements.define('kupo-product-support', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const initialize = () => {
          if (!this.isConnected) return;
          const source = this.querySelector('[data-support-description]');
          const list = this.querySelector('[data-download-list]');
          const downloads = this.querySelector('[data-product-downloads]');
          const seen = new Set();
          list.replaceChildren();
          const links = source?.content.querySelectorAll('a[href]') || [];
          links.forEach(original => {
            let url;
            try { url = new URL(original.getAttribute('href'), window.location.origin); } catch { return; }
            if (!['https:', 'http:'].includes(url.protocol)) return;
            const isDocument = /\.(pdf|zip|dwg|dxf|step|stp|igs|iges|docx?)(?:$)/i.test(url.pathname);
            const isDownload = original.closest('.kupo-download-section') || original.hasAttribute('download');
            if ((!isDocument && !isDownload) || !original.textContent.trim() || seen.has(url.href)) return;
            seen.add(url.href);
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = url.href;
            link.textContent = original.textContent.trim();
            link.setAttribute('aria-describedby', this.querySelector('[data-download-hint]').id);
            const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            icon.setAttribute('viewBox', '0 0 24 24');
            icon.setAttribute('class', 'kupo-product-support__external-icon');
            icon.setAttribute('aria-hidden', 'true');
            icon.setAttribute('focusable', 'false');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'M14 3h7v7M21 3 10 14M10 3H3v18h18v-7');
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', 'currentColor');
            path.setAttribute('stroke-width', '2');
            path.setAttribute('stroke-linecap', 'round');
            path.setAttribute('stroke-linejoin', 'round');
            icon.appendChild(path);
            link.appendChild(icon);
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            item.appendChild(link);
            list.appendChild(item);
          });
          downloads.hidden = seen.size === 0;
          if (seen.size) {
            document.querySelectorAll('main .kupo-download-section').forEach(block => {
              const anchors = Array.from(block.querySelectorAll('a[href]'));
              if (anchors.length && anchors.every(a => seen.has(a.href))) block.hidden = true;
            });
          }
          const inquiry = this.querySelector('[data-product-inquiry]');
          if (!inquiry) return;
          const updateInquiry = () => {
            let variants;
            try { variants = JSON.parse(this.querySelector('[data-support-variants]').textContent); } catch { return; }
            const selectedId = new URLSearchParams(window.location.search).get('variant') || variants.selected;
            const current = variants.variants.find(v => String(v.id) === String(selectedId));
            const url = new URL(inquiry.href);
            url.searchParams.set('sku', current?.sku || this.dataset.title);
            const productUrl = new URL(this.dataset.productUrl);
            if (current) productUrl.searchParams.set('variant', current.id);
            url.searchParams.set('product_url', productUrl.href);
            inquiry.href = url.href;
          };
          updateInquiry();
          inquiry.addEventListener('click', updateInquiry, { signal });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
        else initialize();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
